import styled from 'styled-components';

export const FieldContainer = styled.div`
  display: flex;
  margin-top: 8px;
`;

export const Value = styled.div`
  font-size: 10px;
  line-height: 16px;
  margin: 0;
  flex: 2;
`;

export const IconContainer = styled.span`
  display: flex;
  align-items: center;
  width: 13px;
  height: 16px;
  margin-right: 10px;
`;

export const LabelContainer = styled.span`
  width: 55px;
  height: 20px;
  margin-right: 9px;
  font-size: 10px;
  line-height: 16px;
`;
